'use client'

import { useRef } from 'react'
import { useIsomorphicLayoutEffect } from '../../../../core/hook/useIsomorphicLayout'
import { useTranslation } from '../../../context/ConfigContext'
import { Button } from '../../Button/Button'
import Icon from '../../Icon/Icon'
import { Icons } from '../../Icon/constants'
import { HTMLInputMapId } from '../constants'
import { googleFetchCityFromGeolocationPosition, googleInitAutoComplete } from './helpers'

type GoogleMapAutoCompleteCityProps = {
  onChangePlace: (place: google.maps.places.PlaceResult) => void
  getPlaceFromPlaceId: (placeId: string) => Promise<google.maps.places.PlaceResult | null>
}

const RESULT_TYPES = [] // Use empty array to get all types

const GoogleMapAutoCompleteCity = ({
  onChangePlace,
  getPlaceFromPlaceId,
}: GoogleMapAutoCompleteCityProps) => {
  const autoCompleteRef = useRef<google.maps.places.Autocomplete | null>(null)
  const t = useTranslation()

  const updatePlaceFromPlaceId = (placeId: string) => {
    getPlaceFromPlaceId(placeId)
      .then((place) => {
        if (!place) {
          return
        }

        onChangePlace(place)

        autoCompleteRef.current = googleInitAutoComplete({
          onChangePlace,
          defautNameValue: place.name,
          resultTypes: RESULT_TYPES,
        })
      })
      .catch(console.error) // eslint-disable-line
  }

  const askUserLocation = () => {
    navigator.geolocation.getCurrentPosition(
      async (geolocationPosition) => {
        const city = await googleFetchCityFromGeolocationPosition(geolocationPosition)

        if (city) {
          updatePlaceFromPlaceId(city.place_id)
        }
      },
      (err) => {
        console.error(err) // eslint-disable-line
        alert(t('storelocator-popup-geoloc-authorized', {}, false))
      },
    )
  }

  useIsomorphicLayoutEffect(() => {
    autoCompleteRef.current = googleInitAutoComplete({ onChangePlace, resultTypes: RESULT_TYPES })
  }, [onChangePlace])

  return (
    <div className='sellers-page-filter-search'>
      <div className='sellers-page-filter-search-cities'>
        <input
          type='text'
          placeholder={t('storelocator-search-placeholder', {}, false)}
          id={HTMLInputMapId}
          className='map-input-cities'
        />
        <Icon iconName={Icons.SEARCH} className='sellers-page-filter-search-cities-icon' />
      </div>
      <Button onClick={askUserLocation} label={t('Locate Nearby', {}, false)} />
    </div>
  )
}

export default GoogleMapAutoCompleteCity
